<template>
  <div class="page">
    <div class="tips-warn">
      <img class="icon" src="@/assets/image/tips-warn.png" />
      <span style="color: #3992e9">温馨提示：</span>
      系统将默认不发送确认转入邮件，请知悉!
    </div>
    <div class="content">
      <RadioGroup v-model="form.transferinType">
        <Radio :label="0"> 单个转入</Radio>
        <Radio :label="1"> 批量转入</Radio>
      </RadioGroup>
      <Form label-position="top" style="margin-top: 20px">
        <FormItem
          v-show="form.transferinType === 0"
          class="cc-form-item"
          :label="'转入的域名(' + dnNumber + ')'"
          style="width: 430px"
          required
        >
          <Input
            class="height60"
            v-model="form.domainName"
            placeholder="请输入转入的域名"
            @on-keyup="getDNNumber"
            @on-blur="getAvailableDN"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          :key="form.transferinType"
          v-show="form.transferinType === 1"
          class="cc-form-item"
          :label="'转入的域名(' + dnNumber2 + ')'"
          style="width: 430px"
          required
        >
          <Input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 500 }"
            v-model="form.domainNameMore"
            placeholder="请输入转入的域名,如(test123.cn,123456)"
            @on-keyup="getDNNumber2"
            @on-blur="getAvailableDN2"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          v-show="form.transferinType === 0"
          class="cc-form-item"
          label="转移码"
          style="width: 430px"
          required
        >
          <Input
            class="height60"
            v-model="form.domainCode"
            placeholder="请输入转移码"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          class="cc-form-item"
          label="DNS设置"
          style="width: 430px"
          required
        >
          <RadioGroup v-model="form.dnsType">
            <Radio :label="0"> 原DNS</Radio>
            <Radio :label="1"> 我司DNS</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div style="margin-top: 40px">
        <Button
          :loading="loading"
          type="primary"
          style="margin-right: 20px; height: 60px; width: 120px"
          @click="submit()"
          >提交转入</Button
        >
      </div>
      <div class="row">
        <Checkbox v-model="single"> 我已同意并阅读</Checkbox>
        <span
          style="color: #1c9cdf; cursor: pointer"
          @click="transferRulesModel"
          >《域名转移服务协议》</span
        >
      </div>
    </div>
    <!-- 转入结果 -->
    <transferinListModal
      :show.sync="transferistModalVisibility"
      :data="resultList"
    ></transferinListModal>
    <!-- 域名转移服务协议 -->
    <rule-modal
      :show.sync="transferRulesModelShow"
      :content="transferRulesContent"
      :title="transferRulesTitle"
    ></rule-modal>
  </div>
</template>

<script>
import { transferIntoSave } from "api/domain.js";
import { debounce, trimStr } from "utils/index";
import transferinListModal from "components/transferin/transferinListModal.vue";
import ruleModal from "components/ruleModal.vue";
import transferRules from "assets/rule/transferRules";
export default {
  name: "transferin",
  components: {
    transferinListModal,
    ruleModal,
  },
  data() {
    return {
      form: {
        transferinType: 0,
        domainNameMore: "",
        domainName: "",
        domainCode: "",
        dnsType: 0,
      },
      loading: false,
      dnNumber: 0,
      dnNumber2: 0,
      single: false,
      resultList: [],
      transferistModalVisibility: false,
      // 域名转移服务协议
      transferRulesModelShow: false,
      transferRulesContent: "",
      transferRulesTitle: "",
    };
  },
  methods: {
    // 域名管理系统域名push服务协议
    transferRulesModel() {
      this.transferRulesModelShow = true;
      if (!this.transferRulesContent) {
        this.transferRulesContent = transferRules.content;
        this.transferRulesTitle = transferRules.title;
      }
    },
    // 函数防抖获取输入框中的域名
    getDNNumber: debounce(function () {
      const temp = this.form.domainName.split("\n");
      this.dnNumber = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN() {
      const temp = this.form.domainName.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet = new Set(dnList);
      // storage.setPushSelectDomian([...this.dnSet]);
      this.form.domainName = [...this.dnSet].join("\n");
      this.dnNumber = this.dnSet.size;
    },
    // 函数防抖获取输入框中的域名
    getDNNumber2: debounce(function () {
      const temp = this.form.domainNameMore.split("\n");
      this.dnNumber2 = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN2() {
      const temp = this.form.domainNameMore.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet2 = new Set(dnList);
      // storage.setPushSelectDomian([...this.dnSet]);
      this.form.domainNameMore = [...this.dnSet2].join("\n");
      this.dnNumber2 = this.dnSet2.size;
    },
    async submit() {
      try {
        let ymList = [];
        if (this.form.transferinType === 0) {
          if (!this.form.domainName) {
            this.$Message.warning("请输入域名！");
            return false;
          }
          if (!this.form.domainCode) {
            this.$Message.warning("请输入转移码！");
            return false;
          }
          ymList[0] = `${this.form.domainName},${this.form.domainCode}`;
        } else {
          const list = [...this.dnSet2];
          if (list.length <= 0) {
            this.$Message.warning("请至少输入一个域名");
            return;
          }
          ymList = list;
        }
        if (!this.single) {
          this.$Message.warning(`请阅读并同意《域名转移服务协议》！`);
          return;
        }

        const params = {
          type: this.form.dnsType,
          ymList,
        };
        const { code, data, result } = await transferIntoSave(params);
        if (code === 200 && result) {
          if (data.length === 0) {
            window.location.href = '/shoppingCart'
          } else {
            this.resultList = data;
            this.transferistModalVisibility = true;
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  align-items: center;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.tips-warn {
  padding: 28px 50px;
  border-radius: 8px;
  color: #333333;
  font-size: 14px;
  background-color: #e9effd;
  border: 1px solid #3992e9;
  display: flex;
  align-items: center;
  .icon {
    margin-right: 20px;
    width: 20px;
    height: 19px;
  }
}
.content {
  margin-top: 40px;
  padding: 60px 50px;
  background-color: #fff;
}
/deep/.cc-form-item {
  .ivu-form-item-label {
    padding-bottom: 20px;
  }
}
/deep/.height60 {
  .ivu-input {
    height: 60px;
    line-height: 60px;
  }
  .ivu-input-icon {
    line-height: 60px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 60px;
  }
  .ivu-select-input {
    height: 60px;
  }
  .ivu-select-selected-value {
    height: 60px;
    line-height: 60px;
  }
  .ivu-select-placeholder {
    height: 60px;
    line-height: 60px;
  }
}
</style>
